// @flow
import React, { Component } from 'react';
import Modal from 'react-modal';
import { injectIntl, FormattedMessage } from 'react-intl';
import type { IntlShape } from 'react-intl';

import localizedStrings from 'util/localizedStrings';
import { version } from 'util/constants';
import { getHelpVersion } from 'util/browserUtils';
import './AboutModal.css';

type Props = {
  intl: IntlShape,
  isOpen: boolean,
  onClose: () => void,
};

class AboutModal extends Component<Props> {
  renderPortfolioInfo() {
    return (
      <div className="aboutPanelBody">
        <br />
        <br />
        <b>Extensis</b>
        <br />
        <a
          href="http://www.extensis.com"
          rel="noopener noreferrer"
          target="_blank"
        >
          www.extensis.com
        </a>
        <br />
        US: 800.796.9798
        <br />
        Europe: +44 (0) 1604 654 27
        <br /> <br />
        Copyright © 2021 Celartem, Inc., doing business as Extensis. All rights
        reserved.
      </div>
    );
  }

  renderAPIInfo({ intl: { formatMessage } }) {
    return (
      <div className="aboutPanelBody">
        <FormattedMessage {...localizedStrings.API_SECTION_1} />
        <br />
        <br />
        <b>
          <FormattedMessage {...localizedStrings.API_SECTION_2_PART_3} />
        </b>
        <br />
        <a
          href={formatMessage(localizedStrings.API_CODE_REFERENCE_URL)}
          rel="noopener noreferrer"
          target="_blank"
        >
          <FormattedMessage {...localizedStrings.API_CODE_REFERENCE} />
        </a>
        <br />
        <a
          href={formatMessage(localizedStrings.API_PORTFOLIO_HELP_URL, {
            version: getHelpVersion(),
          })}
          rel="noopener noreferrer"
          target="_blank"
        >
          <FormattedMessage {...localizedStrings.API_PORTFOLIO_HELP} />
        </a>
        <br />
      </div>
    );
  }

  render() {
    const { isOpen, onClose } = this.props;
    const modalStyles = {
      overlay: {
        backgroundColor: 'rgba(127, 127, 127, 0.65)',
        zIndex: 2,
      },
      content: {
        padding: '0px',
        height: '520px',
        width: '600px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        overflow: 'hidden',
      },
    };

    return (
      <Modal
        closeTimeoutMS={150}
        isOpen={isOpen}
        onRequestClose={onClose}
        shouldCloseOnOverlayClick
        style={modalStyles}
      >
        <div style={{ padding: '30px' }}>
          <div className="aboutPanelLogo" />
          <div className="panelHeader">
            <div className="panelTitle">Portfolio Administration</div>
            <div className="panelSubtitle">Version {version}</div>
          </div>

          {this.renderPortfolioInfo()}
          <hr />
          {this.renderAPIInfo(this.props)}
        </div>
      </Modal>
    );
  }
}

export default injectIntl(AboutModal);



// WEBPACK FOOTER //
// ./src/view/App/About/AboutModal.js